export default {
  get_row (state) {
    return state.row
  },
  get_bank (state) {
    return state.bank
  },
  get_active (state) {
    return state.active
  },
  get_shopRow (state) {
    return state.shopRow
  },
  get_userInfo (state) {
    return state.userInfo
  },
  get_systemInfo (state) {
    return state.systemInfo
  },
  get_problemInfo (state) {
    return state.problemInfo
  },
  get_noticeInfo (state) {
    return state.noticeInfo
  },
  get_keepAliveList (state) {
    return state.keepAliveList
  },
  get_selectFreightModels (state) {
    return state.selectFreightModels
  },
  get_payInfo (state) {
    return state.payInfo
  }
}
